<template>
    <div class="metro" v-if="loaded">
        <v-container fluid class="pb-0">
            <v-row align="center" class="next-section-header">
                <v-col cols="12" md="6" class="text-center">
                    <v-img src="../assets/img/logo-next-blanco.png" max-width="300px" class="mx-auto"></v-img>
                    <div class="white--text mx-auto mt-6" style="max-width: 500px" v-html="nextSingleton.descripcionBloque1"></div>
                </v-col>
                <v-col cols="12" md="6" class="">
                    <video class="d-none d-md-flex mx-auto" src="../assets/video/next-final.mp4" controls style="display: flex; height: calc(50vh - 50px); max-width: 100%"></video>
                    <video class="d-flex d-md-none" src="../assets/video/next-final.mp4" width="100%" controls style="display: flex; background-color: black;"></video>
                </v-col>
            </v-row>

            <!-- <v-row justify="center" style="background: linear-gradient(90deg, #ed4952 0%, #ec4e79 50%, #ec529b 100%);"> -->
            <!-- <v-row justify="center" style="background: white;">
                <v-col cols="12" md="8" class="pa-sm-12">
                    <video src="../assets/video/next-final.mp4" width="100%" controls style="display: flex;"></video>
                </v-col>
            </v-row> -->
            <v-row align="center" style="background-color: #ED4953">
                <v-col cols="12" md="6" class="white--text">
                    <v-row justify="center">
                        <v-col cols="10" md="7">
                            <v-img :src="'https://nncms.actstudio.xyz/'+nextSingleton.iconoServicio1Bloque2.path" max-width="150px" class="mx-auto" style="filter: brightness(0) invert(1);"></v-img>
                            <h2 class="text-center my-6" v-html="nextSingleton.tituloServicio2Bloque2">
                            </h2>
                            <div v-html="nextSingleton.descripcionServicio2Bloque2">

                            </div>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6" class="pa-0">
                    <v-img :src="'https://nncms.actstudio.xyz/'+nextSingleton.imagenServicio2Bloque2.path" height="500" class="d-none d-md-flex">
                        <v-img :src="'https://nncms.actstudio.xyz/'+nextSingleton.imagen2Servicio2Bloque2.path" height="500" @mouseover="overImage = true" @mouseout="overImage = false" v-bind:class="{'opac': !overImage}" class="not-opac"></v-img>
                    </v-img>

                    <v-img :src="'https://nncms.actstudio.xyz/'+nextSingleton.imagenServicio2Bloque2.path" width="100%" class="d-md-none" contain>
                        <v-img :src="'https://nncms.actstudio.xyz/'+nextSingleton.imagen2Servicio2Bloque2.path" width="100%" @click="overImage = !overImage" v-bind:class="{'opac': !overImage}" class="not-opac" contain></v-img>
                    </v-img>
                </v-col>
            </v-row>

            <v-container>
                <v-row class="my-12">
                    <v-col cols="12" class="text-center">
                        
                        <div style="font-size: 30px;" v-html="nextSingleton.tituloBloque3"></div>
                    </v-col>
                </v-row>
                <v-row class="my-12">
                    <v-col cols="12" md="4" class="text-center">
                        <v-img :src="'https://nncms.actstudio.xyz/'+nextSingleton.iconoVentaja1Bloque3.path" max-width="60px" class="mx-auto"></v-img>

                        <b class="d-block py-6">{{nextSingleton.tituloVentaja1Bloque3}}</b>
                        <div v-html="nextSingleton.descripcionVentaja1Bloque3"></div>
                    </v-col>
                    <v-col cols="12" md="4" class="text-center">
                        <v-img :src="'https://nncms.actstudio.xyz/'+nextSingleton.iconoVentaja2Bloque3.path" max-width="60px" class="mx-auto"></v-img>

                        <b class="d-block py-6">{{nextSingleton.tituloVentaja2Bloque3}}</b>
                        <div v-html="nextSingleton.descripcionVentaja2Bloque3"></div>
                    </v-col>
                    <v-col cols="12" md="4" class="text-center">
                        <v-img :src="'https://nncms.actstudio.xyz/'+nextSingleton.iconoVentaja3Bloque3.path" max-width="60px" class="mx-auto"></v-img>

                        <b class="d-block py-6">{{nextSingleton.tituloVentaja3Bloque3}}</b>
                        <div v-html="nextSingleton.descripcionVentaja3Bloque3"></div>
                    </v-col>
                </v-row>
            </v-container>

            <v-row align="center">
                <v-col cols="12" md="6" class="pa-0">
                    <v-img :src="'https://nncms.actstudio.xyz/'+nextSingleton.imagenVentajaDestacada.path"></v-img>
                </v-col>
                <v-col cols="12" md="6" class="text-center">
                    <v-row justify="center">
                        <v-col cols="8">
                            <v-img :src="'https://nncms.actstudio.xyz/'+nextSingleton.iconoVentajaDestacada.path" max-width="60px" class="mx-auto" contain></v-img>
                            <h2 class="py-6">{{nextSingleton.tituloVentajaDestacada}}</h2>
                            <div v-html="nextSingleton.descripcionVentajaDestacada"></div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-row align="center" class="next-service-container">
                <v-col cols="12" md="6" class="white--text">
                    <v-row justify="center">
                        <v-col cols="10">
                            <v-img :src="'https://nncms.actstudio.xyz/'+nextSingleton.iconoServicio2Bloque5.path" max-width="55px" class="mx-auto"></v-img>
                            <h2 class="mx-auto text-center my-12">{{nextSingleton.tituloServicio2Bloque5}}</h2>
                            <div v-html="nextSingleton.descripcionServicio2Bloque5">
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6" class="py-0 px-0">
                    <v-img :src="'https://nncms.actstudio.xyz/'+nextSingleton.imagenServicio2Bloque5.path" height="500px"></v-img>
                </v-col>
            </v-row>

            <v-row align="center" class="next-service-container">
                <v-col cols="12" md="6" class="white--text">
                    <v-row justify="center">
                        <v-col cols="10">
                            <v-img :src="'https://nncms.actstudio.xyz/'+nextSingleton.iconoServicio3Bloque6.path" max-width="55px" class="mx-auto"></v-img>
                            <h2 class="mx-auto text-center my-12">{{nextSingleton.tituloServicio3Bloque6}}</h2>
                            <div v-html="nextSingleton.descripcionServicio3Bloque6">
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6" class="py-0 px-0">
                    <v-img :src="'https://nncms.actstudio.xyz/'+nextSingleton.imagenServicio3Bloque6.path" height="500px" class="align-center">
                        <v-row justify="center">
                            <v-col cols="9" md="10">
                                <div v-html="nextSingleton.textoEnImagenServicio3Bloque6" class="white--text text-center" style="font-size: 22px;"></div>
                            </v-col>
                        </v-row>
                    </v-img>
                </v-col>
            </v-row>
        </v-container>

    </div>
</template>

<script>
export default {
    data() {
        return {
            nextSingleton: {
                imagenBloque1:{
                    path: ''
                }
            },
            loaded: false,
            overImage: false
        }
    },
    mounted: function () {
        if (this.locale == "en") {
            fetch('https://nncms.actstudio.xyz/api/singletons/get/Next',{
                    method: "post",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        lang: "en", // return normalized language fields (fieldA_de => fieldA)
                    }),
            })
            .then(data => data.json())
            .then(data => this.nextSingleton = data)
            .then(() => this.loaded = true);
        }else{
            fetch('https://nncms.actstudio.xyz/api/singletons/get/Next')
            .then(data => data.json())
            .then(data => this.nextSingleton = data)
            .then(() => this.loaded = true);
        }
    },
    computed: {
        locale: function () {
            return this.$i18n.locale;
        },
    },
    watch: {
        locale: function () {
            if (this.locale == "en") {
                fetch('https://nncms.actstudio.xyz/api/singletons/get/Next',{
                        method: "post",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            lang: "en", // return normalized language fields (fieldA_de => fieldA)
                        }),
                })
                .then(data => data.json())
                .then(data => this.nextSingleton = data)
                .then(() => this.loaded = true);
            }else{
                fetch('https://nncms.actstudio.xyz/api/singletons/get/Next')
                .then(data => data.json())
                .then(data => this.nextSingleton = data)
                .then(() => this.loaded = true);
            }
        }
    }
}
</script>